import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { Router } from "@angular/router";

import { ILink } from "../models/link.model";
import { Location } from "../utilities/location";

@Component({
	selector: "page-menu",
	template: `
	<div class="list-group hidden-xs" role="tablist">
		<div *ngFor="let item of links; let i = index" >
			<a *ngIf="!item.disabled" (click)="switchSection(item)" class="list-group-item" [ngClass]="{'active': isActive(item.link)}" [attr.data-automation-page-menu-item-a]="i">
				<i class="fa fa-caret-right margin-right-xs"></i> {{item.name}}
			</a>
		</div>
	</div>

	<div class="margin-bottom-md">
		<div class="visible-xs">
			<div class="btn-group bootstrap-select form-control">
				<button type="button" class="btn dropdown-toggle btn-default" data-toggle="dropdown" title="Import Settings" data-automation-page-menu-button>
					<span class="filter-option pull-left">{{selectedValue}}</span>
					&nbsp;
					<span class="bs-caret"><span class="caret"></span></span>
				</button>
				<div class="dropdown-menu open">
					<ul class="dropdown-menu inner" role="menu">
						<li *ngFor="let item of links; let i = index" data-original-index="0" [ngClass]="{'active': isActive(item.link)}" (click)="switchSection(item)">
							<a *ngIf="!item.disabled" tabindex="0" data-tokens="null" [attr.data-automation-page-menu-item-li-a]="i">
								<span class="text">{{item.name}}</span>
								<span class="glyphicon glyphicon-ok check-mark"></span>
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
` })
export class PageMenuComponent implements OnChanges {
	@Input() links: ILink[] = [];

	selectedValue: string;
	isActive = Location.isActiveLink;

	constructor(private router: Router) { }

	ngOnChanges(changes: SimpleChanges) {
		if (changes["links"].currentValue && changes["links"].currentValue[0]) {
			this.selectedValue = this.links[0].name;
		}
	}

	switchSection(selected: ILink) {
		this.selectedValue = selected.name;
		this.router.navigate([selected.link]);
	}
}
